import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DropdownComponent } from './dropdown.component';
import { FilterItemsService } from './filter-items.service';
import { PublisherTreeSelectionModalComponent } from './publishers-tree-selection-modal.component';
import { ProviderTreeSelectionModalComponent } from './providers-tree-selection-modal.component';
import { PublishersSelectedItemsComponent } from './publishers-selected-items.component';
import { OverlayComponent } from "./overlay.component";
import { PageSizeSelectionComponent } from './page-size-selection.component';
import { UploadPictureComponent } from "./upload-picture.component";
import { FieldValidatorService } from './field-validator-service';
import { PublisherSelectionComponent } from './publisher-selection.component';
import { ColorService } from "./color-service";
import { BarChartComponent } from "../dashboard/chart/bar-chart.component";
import { LineChartComponent } from "../dashboard/chart/line-chart.component";
import { PieChartComponent } from "../dashboard/chart/pie-chart.component";
import { FileSaverService } from "./file-saver.servive";
import { PublisherGroupSelectionComponent } from './publisher-group-selection.component';
import { CustomHorizontalScrollService } from './custom-horizontal-scroll.service';
import { SortService } from './sort.service';
import { CountryTreeSelectionModalComponent } from './country-tree-selection-modal.component';

@NgModule({
    imports: [FormsModule, CommonModule],
    declarations: [
        DropdownComponent,
        PublisherTreeSelectionModalComponent,
        ProviderTreeSelectionModalComponent,
        PublishersSelectedItemsComponent,
        OverlayComponent,
        PageSizeSelectionComponent,
        UploadPictureComponent,
        PublisherSelectionComponent,
        BarChartComponent,
        LineChartComponent,
        PieChartComponent,
        PublisherGroupSelectionComponent,
        CountryTreeSelectionModalComponent
    ],
    exports: [
        DropdownComponent,
        PublisherTreeSelectionModalComponent,
        ProviderTreeSelectionModalComponent,
        PublishersSelectedItemsComponent,
        OverlayComponent,
        PageSizeSelectionComponent,
        UploadPictureComponent,
        PublisherSelectionComponent,
        BarChartComponent,
        LineChartComponent,
        PieChartComponent,
        PublisherGroupSelectionComponent,
        CountryTreeSelectionModalComponent
    ],
    providers: [FilterItemsService, FieldValidatorService, ColorService, FileSaverService, CustomHorizontalScrollService, SortService],
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts